<vp-loading-screen
  *ngIf="auth.isLoggedIn"
></vp-loading-screen>
<br/>
<h4 class="titles">{{ 'teams.loginModal.title' | translate }}</h4>